import React, { useId } from "react";

// Generated from the ODT brand geometry - do not hand-edit; regenerate with: node scripts/brand/odt-logo.js .
// Renders in currentColor so CSS controls the tint. Default brand treatment is white.

export const OdtWordmark = ({ title = "Oddtive", ...props }) => {
  const uid = useId();
  const maskId = `odt-wm-${uid}`;
  const titleId = `odt-wm-t-${uid}`;
  return (
    <svg viewBox="0 0 1240 420" role="img" aria-labelledby={titleId} {...props}>
      <title id={titleId}>{title}</title>
      <defs>
        <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="1240" height="420">
          <circle cx="210" cy="210" r="200" fill="#fff"/><path d="M187.4 82A130 130 0 0 0 87.8 254.5L203.7 219L232.6 338A130 130 0 0 0 332.2 165.5L216.3 201Z" fill="#000"/><path d="M490 10H660A200 200 0 0 1 660 410H490Z" fill="#fff"/><path d="M580 100H660A110 110 0 0 1 660 320H580Z" fill="#000"/><path d="M490 160L580 160L580 260L490 260Z" fill="#000"/><path d="M1045 10L1230 10L1230 90L1005 90Z" fill="#fff"/><path d="M1020 90L1110 90L1110 410L1020 410Z" fill="#fff"/><path d="M900 10L997 10L957 90L900 90Z" fill="#fff"/>
        </mask>
      </defs>
      <rect x="0" y="0" width="1240" height="420" fill="currentColor" mask={`url(#${maskId})`} />
    </svg>
  );
};

export const OdtMark = ({ title = "Oddtive", ...props }) => {
  const uid = useId();
  const maskId = `odt-mk-${uid}`;
  const titleId = `odt-mk-t-${uid}`;
  return (
    <svg viewBox="0 0 420 420" role="img" aria-labelledby={titleId} {...props}>
      <title id={titleId}>{title}</title>
      <defs>
        <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="420" height="420">
          <circle cx="210" cy="210" r="200" fill="#fff"/><path d="M187.4 82A130 130 0 0 0 87.8 254.5L203.7 219L232.6 338A130 130 0 0 0 332.2 165.5L216.3 201Z" fill="#000"/>
        </mask>
      </defs>
      <rect x="0" y="0" width="420" height="420" fill="currentColor" mask={`url(#${maskId})`} />
    </svg>
  );
};

export default OdtWordmark;
